import React, { useState, useEffect } from "react";
import "./Header.css";

function Header() {
    const text = "AoyamaTaro".split("");
    const [highlightIndex, setHilighlightIndex] = useState(-1);

    useEffect(() => {
        const startAnimation = () => {
            let index = 0;
            const interval = setInterval(() => {
                setHilighlightIndex(index);
                index++;
                if (index === text.length) {
                    clearInterval(interval);
                }
                setTimeout(() => {
                    setHilighlightIndex(-1);
                }, text.length * 200);

            }, 200);
        }

        const periodicAnimation = setInterval(() => {
            startAnimation(); // アニメーションを発火
        }, 6000); // 6秒ごとに発火


        return () => clearInterval(periodicAnimation);
    }, []);





    return (
        <div className="header__title_name">
            {text.map((char, index) => (
                <span
                    key={index}
                    style={{
                        color: index === highlightIndex ? "#1DA59F" : "white",
                        transition: "color 0.2s",
                    }}
                >
                    {char}
                </span>
            ))}

            {/* <div className="header__title_name">AoyamaTaro</div> */}
        </div>
    );
}

export default Header;